import {put,takeLatest,call} from 'redux-saga/effects'
import * as venueService from "../../../services/venueService"
import {
    CHANGE_VENUE_ALIAS,
    CHANGE_VENUE_ALIAS_SUCCESS,
    CHANGE_VENUE_ALIAS_ERROR
}
    from "../../actions/venue"

function* changeVenueAliasSaga(action) {
    try {
        const data = yield call(venueService.ChangeAlias,action.payload)
        yield put({
            type: CHANGE_VENUE_ALIAS_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: CHANGE_VENUE_ALIAS_ERROR,error: error.data
        })
    }
}

export function* changeVenueAliasSagaWatcher() {
    yield takeLatest(CHANGE_VENUE_ALIAS,changeVenueAliasSaga)
}